import { useAuth } from 'hooks/auth'
import { FeatureReleaseContent } from './FeatureReleaseContent'

export const FeatureRelease = () => {
    const { user, application } = useAuth()
    const historyScope = user?.id && application?.projectName ? JSON.stringify([application.projectName, user.id]) : null
    if (!historyScope) return null
    return <FeatureReleaseContent key={historyScope} historyScope={historyScope} />
}
